(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldOptionDialogController', SegmentFieldOptionDialogController);

    SegmentFieldOptionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SegmentFieldOption'];

    function SegmentFieldOptionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SegmentFieldOption) {
        var vm = this;

        vm.segmentFieldOption = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.segmentFieldOption.id !== null) {
                SegmentFieldOption.update(vm.segmentFieldOption, onSaveSuccess, onSaveError);
            } else {
                SegmentFieldOption.save(vm.segmentFieldOption, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:segmentFieldOptionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
